import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  listDomicilios: [],
};
export const mutations = {
  GET_DOMICILIOS({ context }, result_domicilios) {
    state.loading = false;
    if (result_domicilios) {
      let domicilios = [];
      Object.entries(result_domicilios).forEach(([key, val]) => domicilios.push(val));
      return (state.listDomicilios = domicilios);
    }
  },
  SAVE_DOMICILIO({ context }, domicilio) {
    state.newDomicilio = Object.assign({}, domicilio);
  },
};
export const actions = {
  GET_DOMICILIOS({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          // console.log(response.data.data);
          commit("SET_LOADING", false);
          commit("GET_DOMICILIOS", response.data.data.domicilios);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  SAVE_DOMICILIO({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(data)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("SAVE_DOMICILIO", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  DELETE_DOMICILIO({ commit }, id) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.delete(id)//funcion de ApiService
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
};

export const getters = {
  listDomicilios: state => state.listDomicilios,
};
